# Features

SEEK job ads require a number of SEEK-specific inputs:

- [Contact people] specify who to contact if there’s a problem with the job ad.

- [Locations] specify the location of the position.
  These can either be suggested interactively or mapped from a partner’s location ontology.

- [Job categories] specify the job’s occupational category.
  These can either be suggested interactively or mapped from a partner’s job category ontology.

- [Ad selection] enables the hirer to interactively select a SEEK [ad product].
  It returns the ad product’s exact price based on the hirer, location, role title & job category.

The following inputs are optionally available:

- Attach a [questionnaire] to be filled out by the candidate.
  The candidate’s responses are available via [Optimised Apply].

- Associate a [brand] to promote the hirer’s brand when the appropriate [ad product] is selected.

Once these inputs and the remaining [position profile] attributes have been collected,
you can create a job ad using the [job posting] mutations.

[ad product]: https://au.employer.seek.com/products/jobads
[ad selection]: /use-cases/job-posting/ad-selection
[brand]: /use-cases/job-posting/branding
[contact people]: /use-cases/job-posting/contact-people
[job categories]: /use-cases/job-posting/job-categories
[job posting]: /use-cases/job-posting/managing-job-ads/posting-a-job-ad
[locations]: /use-cases/job-posting/locations
[Optimised Apply]: /use-cases/application-export/questionnaire-submissions
[position profile]: /use-cases/job-posting/position-profiles
[questionnaire]: /use-cases/job-posting/questionnaires
